
import { Component, Prop, State, h, Watch } from '@stencil/core';
import ChatSDK from 'test-iso-chat-sdk';
import { getDeviceID } from '../../../lib/helpers';
// import '../../../stories/Components/Head/Head';
// import '../../../stories/Components/Head/ClosedHeader/ClosedHead';
import '../../../global/app.css';
import {closeChat} from '../../../index';
import './chat-test.css';
@Component({
  tag: 'chat-test',
  shadow: true,
  styles: `
  :host {
    display: block;
      width: 95vw;
      max-width: 500px;
      position: fixed;
      right: 5px;
     bottom: 2px;
     box-shadow: 0px 0px 4px #6d5555;
    border-radius: 15px 15px 0px 0px;
    z-index: 2147483647 !important;
    background-color: #FFF;
    overflow: hidden;
    }

    .isometrik-quickchat {
      box-shadow: 0px 0px 20px 1px #6294a926;
    }
    .openChat {
    height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;      
    }
  `,
})
export class ChatTest {
  ///all props require to used this package start
 // Required Props
 @Prop() baseUrl: string;
 @Prop() hostUrl: string;
 @Prop() licenseKey: string;
 @Prop() appSecret: string;
 @Prop() userSecret: string;
 @Prop() userToken: string;
 @Prop() isometrikUserId: string;
 @Prop() projectId: string;
 @Prop() keysetId: string;
 @Prop() accountId: string;
 @Prop() conversationId: string;
 @Prop() isDark?: boolean;
 @Prop() darkThemeUrl: string;
 @Prop () lightThemeUrl: string;

 // State Management
 @State() isInitialized: boolean = false;
 @State() findUserId: any = {};
 @State() mqttClient: any = null;
 @State() mqttInitialized: boolean = false;
 @State() allMessages: any[] = [];
 @State() userMetaData: any = null;
 @State() conversationMetaData: any = null;
 @State() isMessageLimitEnd: boolean = false;
 @State() skip: number = 0;
 @State() isMessagesLoading: boolean = false;
 @State() isMessageSending: boolean = false;
 @State() deviceId: string = '';
 @State() isScrollToBottom: boolean = true;
 @State() isScrollToTop: boolean = false;
 @State() isChatClosed: boolean = false;
 @State() isChatMinimized: boolean = false;
 @State() isSubscribedToTopic: boolean = false;
 @State() isMessageListenerAttached: boolean = false;
 @State() isInitialCallDone: boolean = false;
 @State() isTyping: boolean = false;

 private typingTimeout: NodeJS.Timeout | null = null;
 private refetchInterval: NodeJS.Timeout | null = null;

 async componentWillLoad() {
  this.loadTheme()
   try {
     const deviceId = await getDeviceID();
     this.deviceId = deviceId;

     ChatSDK.initializeInstance({
       baseUrl: this.baseUrl,
       licenseKey: this.licenseKey,
       appSecret: this.appSecret,
       userSecret: this.userSecret,
       userToken: this.userToken,
     },);
     this.isInitialized = true;

     await this.setupMqttClient();
     await this.getUserDetails();
     await this.getUserConversationDetails();
     
     if (!this.isMessageLimitEnd) {
       await this.getMessages(this.skip);
     }
   } catch (error) {
     this.isInitialized = false;
     console.error('ChatSDK initialization failed:', error);
   }
 }

 
 private cleanupMQTT() {
   if (this.mqttClient && this.mqttClient.client) {
     this.mqttClient.client.removeAllListeners('message');

     if (this.refetchInterval) {
       clearInterval(this.refetchInterval);
       this.refetchInterval = null;
     }
     this.mqttClient = null;
     this.mqttInitialized = false;
     this.isSubscribedToTopic = false;
     this.isMessageListenerAttached = false;
     this.isInitialCallDone = false;
     this.baseUrl = null;
    this.hostUrl = null;
    this.licenseKey = null ;
    this.appSecret = null;
    this.userSecret = null;
    this.userToken = null;
    this.isometrikUserId = null;
    this.projectId = null;
    this.keysetId = null;
    this.accountId = null;
    this.conversationId = null;
   }
 }

 async setupMqttClient() {
   if (this.mqttClient) {
     this.cleanupMQTT();
   }
   const mqttClient = ChatSDK.getInstance().initializeMqtt({
     hostUri: this.hostUrl,
     clientId: this.isometrikUserId,
     licenseKey: this.licenseKey,
     projectId: this.projectId,
     keysetId: this.keysetId,
     accountId: this.accountId,
     deviceId: this.deviceId,
   });

   this.mqttClient = mqttClient;
   console.log(this.mqttClient, 'mqtt client');
   
  if(this.mqttClient){
    this.mqttInitialized = true;

    this.mqttClient.client.on('connect', async () => {
       if (this.refetchInterval) {
         clearInterval(this.refetchInterval);
         this.refetchInterval = null;
       } 
       if (!this.isInitialCallDone) {
         await ChatSDK.getInstance().message.putRead({ conversationId: this.conversationId });
         await this.refetchMessages();
         this.isInitialCallDone = true;
       }
     });

    this.mqttClient.client.on('message', async (topic: any, message: any) => {
      const parsedMessage = JSON.parse(message.toString());
      console.log(`klmnop new Incoming message form11111 ${topic}:1`, parsedMessage);
      
      if (parsedMessage?.action === 'messageRead') {
        this.allMessages = this.allMessages?.map(message => 
          message?.messageId === parsedMessage?.messageId ? { ...message, readByAll: true } : message
        );
      }
  
      if (parsedMessage?.action === 'typingEvent' && parsedMessage.userId != this.userMetaData.userId) {
        this.isTyping = true;
      } else {
        this.isTyping = false;
      }
  
      if (parsedMessage?.action === 'multipleMessagesRead' && parsedMessage.userId != this.userMetaData?.userId) {
        this.allMessages = this.allMessages?.map(message =>
          message?.readByAll != true && (message?.senderId || message?.senderInfo?.userId) == this.userMetaData?.userId 
            ? { ...message, readByAll: true } 
            : message
        );
      }
  
      if (parsedMessage?.action == 'messagesDeleteForAll') {
        this.allMessages = this.allMessages.filter((message: any) => 
          message.messageId != parsedMessage.messageIds[0]
        );
      }
  
      if (parsedMessage?.senderId == this.userMetaData?.userId && parsedMessage?.action == 'chatMessageSent') {
        this.changeMessageSendingState(false);
        this.allMessages = this.allMessages.map(message => 
          message.messageId == parsedMessage.messageId || message.id == '12' 
            ? parsedMessage 
            : message
        );
      }
  
      if (parsedMessage?.action == 'messageDelivered' && parsedMessage.senderId != this.userMetaData?.userId) {
        this.allMessages = this.allMessages?.map(message => 
          message?.messageId === parsedMessage?.messageId 
            ? { ...message, deliveredToAll: true } 
            : message
        );
      }
  
      if (
        parsedMessage?.senderId != this.userMetaData?.userId &&
        parsedMessage?.action == 'chatMessageSent' &&
        parsedMessage?.action != 'typingEvent' &&
        parsedMessage?.action != 'messageRead' &&
        parsedMessage?.action != 'multipleMessagesRead' &&
        parsedMessage?.action != 'messageRead' &&
        parsedMessage?.action != 'messageDelivered'
      ) {
        this.allMessages = [...this.allMessages, parsedMessage];
        try {
          await ChatSDK.getInstance().message.putIndicateDelivered({
            conversationId: parsedMessage?.conversationId,
            messageId: parsedMessage?.messageId
          });
        } catch (error) {
          console.log(error, 'putIndicateDelivered request error');
        }
      }
    });

    this.mqttClient.client.on('error', (error: any) => {  
       console.log('MQTT connection error:--->', error);
       this.isInitialCallDone = true;
       if (!this.refetchInterval) {
         this.refetchInterval = setInterval(() => {
           console.log('MQTT connection failed, refetching messages...');
           this.refetchMessages();
         }, 30000);
       }
     });
  }
 }


 async getUserDetails() {
   try {
     const res = await ChatSDK.getInstance().user.getUserDetails();
     this.userMetaData = {
      //@ts-ignore
       userId: res?.userId || '',
       userIdentifier: res?.userIdentifier || '',
       //@ts-ignore
       firstName: res?.metaData?.firstName || '',
       //@ts-ignore
       lastName: res?.metaData?.lastName || '',
       updatedAt: res?.updatedAt || '',
       userName: res?.userName || '',
       online: res?.online || '',
       userProfileImageUrl: res?.userProfileImageUrl || '',
       //@ts-ignore
       profilePic: res?.metaData?.profilePic || '',
     };
   } catch (error) {
     console.error('getUserDetails fetching error:', error);
   }
 }

 async getUserConversationDetails() {
   try {
     const res = await ChatSDK.getInstance().Conversation.getConversationDetails(
       { conversationId: this.conversationId },
       this.conversationId
     );
     this.conversationMetaData = res.conversationDetails;
   } catch (error) {
     console.error('getConversationDetails fetching error:', error);
   }
 }

 async getMessages(skip: number) {
   this.isMessagesLoading = true;
   this.isScrollToTop = true;

   try {
     const res = await ChatSDK.getInstance().message.getMessages({
       conversationId: this.conversationId,
       limit: 20,
       skip: skip
     });

     if (skip === 0) {
       this.allMessages = [...res.messages.reverse()];
     } else {
       this.allMessages = [...res.messages.reverse(), ...this.allMessages];
     }
   } catch (error) {
     if (error.errorCode === 1) {
       this.isMessageLimitEnd = true;
     }
     console.error('Error fetching messages:', error);
   } finally {
     this.isMessagesLoading = false;
   }
 }

 async deleteMessageFromSelf(payload: { conversationId: string; messageIds: string }) {
   try {
     this.allMessages = this.allMessages.filter(
       (message: any) => message.messageId !== payload.messageIds
     );
     await ChatSDK.getInstance().message.deleteMessageSelf(payload);
   } catch (error) {
     console.error('Delete self error:', error);
   }
 }

 async deleteMeassageFromEveryOne(payload: { conversationId: string; messageIds: string }) {
   try {
     this.allMessages = this.allMessages.filter(
       (message: any) => message.messageId !== payload.messageIds
     );
     await ChatSDK.getInstance().message.deleteMessagesEveryone(payload);
   } catch (error) {
     console.error('Delete all error:', error);
   }
 }

 // State Update Methods
 changeScrollToBottomState = (newState: boolean) => {
   this.isScrollToBottom = newState;
 };

 changeScrollToTopState = (newState: boolean) => {
   this.isScrollToTop = newState;
 };

 updateSkip = () => {
   if (!this.isMessageLimitEnd) {
     this.skip += 20;
   }
 };

 updateAllMessages = (newMessages: any[]) => {
   this.allMessages = newMessages;
 };

 refetchMessages = async () => {
   this.isScrollToBottom = true;
   this.skip = 0;
   this.isMessageLimitEnd = false;
   await this.getMessages(0);
 };

 changeMessageSendingState = (newState: boolean) => {
   this.isMessageSending = newState;
 };

 // Watchers
 @Watch('skip')
 handleSkipChange() {
   if (!this.isMessageLimitEnd) {
     this.getMessages(this.skip);
   }
 }

 @Watch('isDark')
 loadTheme() {
   const themeLink = document.getElementById('theme-style') as HTMLLinkElement;
   if (themeLink) {
     themeLink.href = this.isDark ? `${this.darkThemeUrl}` : `${this.lightThemeUrl}`;
   } else {
     // Create a new link element if it doesn't exist
     const link = document.createElement('link');
     link.id = 'theme-style';
     link.rel = 'stylesheet';
     link.href = this.isDark ? `${this.darkThemeUrl}` : `${this.lightThemeUrl}`;
     document.head.appendChild(link);
   }
 }

 @Watch('isTyping')
 handleTypingChange() {
   if (this.isTyping) {
     if (this.typingTimeout) {
       clearTimeout(this.typingTimeout);
     }
     this.typingTimeout = setTimeout(() => {
       this.isTyping = false;
     }, 10000);
   }
 }

 disconnectedCallback() {
   this.cleanupMQTT();
   
   if (this.typingTimeout) {
     clearTimeout(this.typingTimeout);
     this.typingTimeout = null;
   }
 }
  render() {
    return (
      <div>
        {/* <div>Hello from chat, {this.name}</div>
        <div class='.someclass'>SDK Initialized  : {this.isInitialized ? 'Yes' : 'No'}</div>
        <div>MQTT Initialized: {this.mqttInitialized ? 'Yes' : 'No'}</div>
        <button onClick={this.handleChatOpen} style={{ fontSize: '16px', fontWeight: 'bold', border: 'none', background: 'none', borderRadius: '100px', cursor: 'pointer' }}>
          <img src="https://flexcrew.s3.us-west-1.amazonaws.com/Button_86f6afeafb.png" />
        </button> */}
        {/* <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', padding: '10px 30px 0 0' }}> */}
        <div class="isometrik-quickchat">
          {!this.isChatClosed ? (
            this.isChatMinimized ? (
              <div class="minimizedChat">
                <chat-header-closed
                  conversationDetails={this.conversationMetaData}
                  onMinimize={() => {
                    this.isChatMinimized = false;
                  }}
                  onClose={() => {
                    closeChat(this.conversationId);
                  }}
                />
              </div>
            ) : (
              <div class="openChat">
                <chat-header
                isDark = {this.isDark}
                  conversationDetails={this.conversationMetaData}
                  onMinimize={() => {
                    this.isChatMinimized = true;
                  }}
                  onClose={() => {
                    this.isChatClosed = true;
                    closeChat(this.conversationId);
                  }}
                  isTyping={this.isTyping}
                />

                <chat-body
                 isDark = {this.isDark}
                  isMessagesLoading={this.isMessagesLoading}
                  updateSkip={this.updateSkip}
                  isMessageLimitEnd={this.isMessageLimitEnd}
                  allMessages={this.allMessages}
                  userMetaData={this.userMetaData}
                  skip={this.skip}
                  isScrollToBottom={this.isScrollToBottom}
                  changeScrollToBottomState={this.changeScrollToBottomState}
                  isMessageSending={this.isMessageSending}
                  isScrollToTop={this.isScrollToTop}
                  changeScrollToTopState={this.changeScrollToTopState}
                  deleteForSelf={this.deleteMessageFromSelf}
                  deleteForAll={this.deleteMeassageFromEveryOne}
                  isChatClosed={this.isChatClosed}
                  isChatMinimized={this.isChatMinimized}
                  updateAllMessages={this.updateAllMessages}
                  conversationId = {this.conversationId}
                />
                <chat-footer
                isDark = {this.isDark}
                  userMetaData={this.userMetaData}
                  updateAllMessages={this.updateAllMessages}
                  changeMessageSendingState={this.changeMessageSendingState}
                  changeScrollToBottomState={this.changeScrollToBottomState}
                  refetchMessages={this.refetchMessages}
                  allMessages={this.allMessages}
                  conversationId = {this.conversationId}
                />
              </div>
            )
          ) : null}
          {/* <body /> */}
        </div>
        {/* </div> */}
      </div>
    );
  }
}